<template>
  <div class="HardwarePanel panel">
    <div class="HardwarePanel-container">
      <div class="HardwareControls-Container">
        <div class="columnControls">
          <div @change="powerScentDevice">
            <toggle-switch id="scent-system-toggle" title="Geursysteem" icon="power-off" :state="this.power"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ToggleSwitch from './subcomponents/ToggleSwitch.vue';
import * as signalR from "@microsoft/signalr";

export default {
  name: 'HardwarePanel',
  props: {
    displayError: null
  },
  data() {
    return {
      power: false
    };
  },
  components: {
    ToggleSwitch
  },
  methods: {
    powerScentDevice() {
      let ref = this;
      this.power = !this.power;
      if (this.connection.connectionState === 'Disconnected') {
        ref.deviceNotAvailable('[SERVER ERROR] Geursysteem is niet bereikbaar.');
      }

      if (this.power) {
        this.connection.invoke("sendMessage", "state", "true");
      } else {
        this.connection.invoke("sendMessage", "state", "false");
      }
    },
    deviceNotAvailable(message) {
      this.$emit('displayError', message);
    },
    async connect(connection) {
      let ref = this;
      try {
        await connection.start();
        connection.on("ReceiveMessage", function (user, message) {
          let scentSystemAvailable = (message === "true");
          document.getElementById("scent-system-toggle").children[1].firstChild.firstChild.checked = scentSystemAvailable;
          this.power = scentSystemAvailable;
        });

        await connection.invoke("sendMessage", "user", "message");

      } catch (err) {
        ref.deviceNotAvailable('[ERROR] Geursysteem is niet beschikbaar.');
      }
    }
  },
  mounted() {
    const connection = new signalR.HubConnectionBuilder()
        .withUrl("//" + process.env.VUE_APP_API_URL_HARDWARESERVICE + "/hardwarepanel", {
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets
        })
        .configureLogging(signalR.LogLevel.Information)
        .build();

    this.connection = connection;
    this.connect(connection);
  }

}
</script>

<style scoped>
@font-face {
  font-family: "Gotham Book";
  src: url("../../public/fonts/Gotham-Book.woff2");
}

@font-face {
  font-family: "Gotham Medium";
  src: url("../../public/fonts/GothamMedium.ttf");
}

.HardwarePanel {
  display: flex;
  flex-direction: column;
  flex-grow: 1.1;
  padding-left: 2%;
  padding-right: 2%;
  font-family: "Gotham Book", serif;
}

.HardwarePanel-container {
  display: flex;
  flex-direction: row;
  flex-grow: 1;
}

.HardwareControls-Container {
  display: flex;
  flex-direction: row;
  height: 80%;
  margin-top: 39px;
  padding-left: 40px;
  padding-top: 20px;
  border-top: solid rgba(255, 255, 255, 0.2) 1px;
}

.columnControls {
  display: flex;
  flex-direction: column;
}
</style>